import { render, staticRenderFns } from "./CoherenceSemanticsPanel.vue?vue&type=template&id=34c20c8d&scoped=true"
import script from "./CoherenceSemanticsPanel.vue?vue&type=script&lang=js"
export * from "./CoherenceSemanticsPanel.vue?vue&type=script&lang=js"
import style0 from "./CoherenceSemanticsPanel.vue?vue&type=style&index=0&id=34c20c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c20c8d",
  null
  
)

export default component.exports